import { render, staticRenderFns } from "./PersonalDataPage.vue?vue&type=template&id=2929a98c&scoped=true"
import script from "./PersonalDataPage.vue?vue&type=script&lang=js"
export * from "./PersonalDataPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929a98c",
  null
  
)

export default component.exports